import React from "react";
import { Link } from "react-router-dom";
import { useImagery } from "@/hooks/useCatalog";

export function Hero() {
  const { data } = useImagery();
  const img = data?.hero_primary || "https://images.unsplash.com/photo-1585960622850-ed33c41d6418?auto=format&fit=crop&w=1600&q=80";

  return (
    <section data-testid="hero-section" className="relative h-[88vh] min-h-[560px] w-full overflow-hidden">
      <img src={img} alt="Woman wearing ÉLORA gold jewellery" className="absolute inset-0 h-full w-full object-cover object-center animate-scale-in" />
      <div className="absolute inset-0 bg-gradient-to-r from-ink/70 via-ink/30 to-transparent" />
      <div className="relative mx-auto flex h-full max-w-7xl items-center px-4 sm:px-6 lg:px-8">
        <div className="max-w-xl text-ivory">
          <span className="inline-block animate-fade-up reveal-delay-1 text-luxe text-xs font-medium text-gold">
            The 2026 Collection
          </span>
          <h1 className="mt-4 animate-fade-up reveal-delay-2 font-serif text-4xl font-light leading-[1.08] sm:text-5xl lg:text-6xl">
            Jewellery That Tells Your Story
          </h1>
          <p className="mt-5 max-w-md animate-fade-up reveal-delay-3 text-base leading-relaxed text-ivory/85 sm:text-lg">
            Discover timeless pieces designed to make every moment shine.
          </p>
          <div className="mt-9 flex animate-fade-up reveal-delay-4 flex-col gap-3 sm:flex-row">
            <Link
              to="/shop"
              data-testid="hero-shop-cta"
              className="bg-gold px-9 py-4 text-center text-[11px] font-semibold uppercase tracking-[0.2em] text-white transition-colors hover:bg-gold-dark"
            >
              Shop Now
            </Link>
            <Link
              to="/collections"
              data-testid="hero-explore-cta"
              className="border border-ivory/80 px-9 py-4 text-center text-[11px] font-semibold uppercase tracking-[0.2em] text-ivory transition-colors hover:border-gold hover:bg-ivory hover:text-ink"
            >
              Explore Collection
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
